/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { isEmpty, isFunction } from "lodash";
import DataComponent from "../DataComponent/";
import classnames from "classnames";
import { getAddSizeUnit } from "../../utils/size";

const columnMaxSize = 12;

const getFilterWidth = (filter, filters) => {
  let filterWidth = `${100 / filters.length}%`;
  if (filter.size)
    filterWidth = `${(100 / columnMaxSize) * Number(filter.size)}%`;
  if (filter.width) filterWidth = getAddSizeUnit(filter.width);
  return filterWidth;
};

const Filters = ({
  filters = [],
  submit = () => { },
  isLoading,
  form,
  onChange,
  isSubmitButton = true
}) => {

  return (
    <div
      className={classnames("filters-wrap")}
    >
      <div className={classnames("filters")}>
        {!isEmpty(filters) &&
          filters.map((filter, idx) => (
            (isFunction(filter.isHide) && filter.isHide()) ||
              (!isFunction(filter.isHide) && filter.isHide) ?
              <React.Fragment key={idx} /> :
              <React.Fragment key={idx}>
                <div
                  style={{
                    width: getFilterWidth(filter, filters),
                  }}
                  className={classnames("filter-item", filter.wrapClassName || "")}
                  key={idx}
                >
                  {filter.title && (
                    <label className="filter-label">{filter.title}</label>
                  )}
                  <div className="filter-component">
                    <DataComponent
                      onChange={onChange}
                      field={{
                        type: "input",
                        onKeyPress: (e) => {
                          if (e.key === "Enter") {
                            submit(e);
                          }
                        },
                        ...filter,
                      }}
                      name={filter.key}
                      form={form}
                    />
                  </div>
                </div>
              </React.Fragment>
          ))}
      </div>
      {isSubmitButton &&
        <div
          className="filter-buttons"
          style={{
            width: "108px",
          }}
        >
          <DataComponent
            field={{
              type: "button",
              color: "line",
              action: submit,
              label: '적용',
              disabled: isLoading
            }}
          />
        </div>
      }
    </div>
  );
};
export default Filters;
